import { Box, BoxProps, Heading, HeadingProps } from "@chakra-ui/react";
import { ReactNode } from "react";

export type LegendProps = HeadingProps;

export function Legend({ sx, ...rest }: LegendProps) {
  return (
    <Heading
      as="legend"
      size="xs"
      color="gray.600"
      pb={1}
      mb={3}
      borderBottomWidth={1}
      display="block"
      width="100%"
      {...rest}
      sx={{
        "fieldset.fieldset-well &": {
          mt: 1,
          mb: 2,
          float: "left",
          "+ *": {
            clear: "both",
          },
        },
        ...sx,
      }}
    />
  );
}
export type FieldsetProps = BoxProps & {
  legend?: ReactNode;
};

export default function Fieldset({ legend, children, ...rest }: FieldsetProps) {
  return (
    <Box as="fieldset" my={3} {...rest}>
      {legend && <Legend>{legend}</Legend>}
      {children}
    </Box>
  );
}

export function FieldsetWell(props: FieldsetProps) {
  return (
    <Fieldset
      className="fieldset-well"
      backgroundColor="gray.200"
      borderWidth={1}
      borderColor="gray.300"
      borderRadius="md"
      px=".5rem"
      {...props}
    />
  );
}
